export default "__VITE_ASSET__Cc9C1vog__"